function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP marketing consent checkbox
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { acceptMarketingConsent } from '../../actions/index';
import { SITE_CONTENT } from '../../reducers/content/Site.content';
import './MarketingConsent.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class MarketingConsent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "accept", checked => {
      this.props.acceptMarketingConsent(checked);
    });
    _defineProperty(this, "getLabel", () => {
      const {
        application,
        marketingConsentContent
      } = this.props;
      const clubAbbreviation = application?.club?.abbreviation || '';

      // Check for club-specific content first
      if (clubAbbreviation && marketingConsentContent[clubAbbreviation]) {
        return marketingConsentContent[clubAbbreviation].label;
      }

      // Use default content with club name replacement
      let label = marketingConsentContent.default.label;
      if (clubAbbreviation) {
        label = label.replace(/\[CLUB_NAME\]/g, clubAbbreviation);
      }
      return label;
    });
  }
  render() {
    const {
      application,
      marketingConsent,
      marketingConsentContent
    } = this.props;
    const clubAbbreviation = application?.club?.abbreviation || '';

    // Hide marketing consent for specified clubs
    if (marketingConsentContent.hiddenClubs?.includes(clubAbbreviation)) {
      return null;
    }
    const label = this.getLabel();
    return /*#__PURE__*/_jsx("div", {
      className: "marketingConsent",
      children: /*#__PURE__*/_jsxs("div", {
        className: "checkbox-container",
        children: [/*#__PURE__*/_jsx("input", {
          name: "marketingConsent",
          type: "checkbox",
          checked: marketingConsent.value,
          value: "1",
          onChange: e => this.accept(e.target.checked)
        }), /*#__PURE__*/_jsx("label", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        })]
      })
    });
  }
}
_defineProperty(MarketingConsent, "defaultProps", {
  marketingConsent: {
    error: false,
    required: false,
    valid: true,
    value: false
  },
  marketingConsentContent: {
    ...SITE_CONTENT.marketingConsentContent
  }
});
const mapStateToProps = ({
  application,
  marketingConsent
}) => {
  return {
    application,
    marketingConsent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    acceptMarketingConsent: value => {
      dispatch(acceptMarketingConsent(value));
    }
  };
};
const VisibleMarketingConsent = connect(mapStateToProps, mapDispatchToProps)(MarketingConsent);
export default VisibleMarketingConsent;